<div class="mobile-only">
  <wa-callout variant="warning">
    <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
    <strong>This site is not designed for mobile use.</strong><br/>
    Please open it on a larger device instead.
  </wa-callout>
</div>
<div class="desktop-only">
  <div class="wa-stack wa-gap-xl">
    <div class="wa-flank wa-gap-xl">
      <div class="wa-heading-xl">Semester Surveys</div>
        @if (user()?.isAdmin) {
          <div class="justify-content-end">
          <wa-button appearance="accent" variant="brand" size="s" (click)="showCreateDialog()">
            <wa-icon slot="end" name="plus" variant="solid"></wa-icon>
            add
          </wa-button>
          </div>

        }
    </div>
    <div>
      @if (!surveysView() || surveysView()?.length === 0) {
        @if (user()?.isAdmin) {
          <wa-callout variant="warning">
            <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
            <strong>No surveys found.</strong><br/>
            Click on <b>add</b> to create a survey.
          </wa-callout>
        } @if (!user()?.isAdmin || filter !== defaultFilter) {
          <wa-callout variant="warning">
            <wa-icon slot="icon" name="triangle-exclamation" variant="regular"></wa-icon>
            <strong>No surveys found.</strong><br/>
            Currently, no surveys are available on this system.
          </wa-callout>
        }
      }
    </div>
    @if(surveys.hasValue()) {
    <wa-scroller orientation="vertical" class="survey-scroller">
      <div class="wa-stack">
        @for (survey of surveysView(); track survey.id) {
          <app-survey-list-element
            [survey]="survey"
            [showAdminControls]="!!user() && (user()?.isAdmin ?? false)"
            (submitExclusionsEvent)="submitExclusions(survey)"
            (editSurveyEvent)="edit($event)"
            (editAssignmentsEvent)="gotoAssignment($event)"
            (publishSurveyEvent)="publishAssignment($event)"
            (removeSurveyEvent)="remove($event)"
            (optimizationDashboardEvent)="gotoDashboard($event)">
          </app-survey-list-element>
        }
      </div>
    </wa-scroller>
    }
  </div>
</div>


<!--
          @if (filter !== defaultFilter) {
            <wa-button class="wa-size-m" appearance="outlined" variant="danger"
                            (click)="resetFilter()"><wa-icon name="filter-slash" variant="solid" label="reset filters"></wa-icon></wa-button>
          } @else {
            <wa-button class="wa-size-m" appearance="outlined" variant="brand"
                            (click)="showFilterDialog()"><wa-icon  name="filter" variant="solid" label="filter"></wa-icon></wa-button>
          }
          -->
